import { render, staticRenderFns } from "./dialog-approve-xupinzhisp.vue?vue&type=template&id=292fb672&scoped=true&"
import script from "./dialog-approve-xupinzhisp.vue?vue&type=script&lang=js&"
export * from "./dialog-approve-xupinzhisp.vue?vue&type=script&lang=js&"
import style0 from "./dialog-approve-xupinzhisp.vue?vue&type=style&index=0&id=292fb672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292fb672",
  null
  
)

export default component.exports